import { render, staticRenderFns } from "./WebSocketDialog.vue?vue&type=template&id=27e4f991"
import script from "./WebSocketDialog.vue?vue&type=script&lang=js"
export * from "./WebSocketDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports